<div class="modal-header">
    <h1 class="modal-title">
        {{ i18n._956_HIGH_PRIORITY_ALERT_RECEIVED | translate }}
    </h1>
    <img
        src="assets/compas-logo.svg"
        alt
        role="presentation"
    />
</div>
<div class="modal-body">
    <div class="container-fliuid">
        <ng-container *ngFor="let i of vm.notifications; let last = last">
            <div
                class="row"
                *ngIf="!vm.notificationAcks[i.id]"
            >
                <div class="col-12">
                    <h2>{{ i.subject }}</h2>
                    <p
                        notificationBody
                        [body]="i.body"
                        [links]="i.notificationLinks"
                        (linkClick)="onLinkClick($event)"
                    ></p>
                    <div class="text-right">
                        <button
                            type="button"
                            class="btn btn-primary"
                            (click)="onAcknowledgeClick(i)"
                        >
                            {{ i18n._957_ACKNOWLEDGE | translate }}
                        </button>
                    </div>
                </div>
            </div>
            <hr *ngIf="!vm.notificationAcks[i.id]" />
        </ng-container>
    </div>
</div>
